/**
 * 神奇大学redux
 */
import { combineReducers } from "redux";

export const types = {
  SET_QUERY_SCHOOL_NAME: "SCHOOL_QUERY/SET_QUERY_SCHOOL_NAME",

  SET_LEVEL_FILTER_ID: "SCHOOL_FILTER/SET_LEVEL_FILTER_ID",
  SET_TAG_FILTER_ID: "SCHOOL_FILTER/SET_TAG_FILTER_ID",
  SET_PROPERTY_FILTER_ID: "SCHOOL_FILTER/SET_PROPERTY_FILTER_ID",
  SET_PROVINCE_FILTER_ID: "SCHOOL_FILTER/SET_PROVINCE_FILTER_ID",

  SET_LIMIT_MARK_ARRAY: "SCHOOL_FILTER/SET_LIMIT_MARK_ARRAY",
  SET_LEVEL_MARK_ARRAY: "SCHOOL_FILTER/SET_LEVEL_MARK_ARRAY",
  SET_TAG_MARK_ARRAY: "SCHOOL_FILTER/SET_TAG_MARK_ARRAY",
  SET_PROPERTY_MARK_ARRAY: "SCHOOL_FILTER/SET_PROPERTY_MARK_ARRAY",
  SET_PROVINCE_MARK_ARRAY: "SCHOOL_FILTER/SET_PROVINCE_MARK_ARRAY",
};

const initialState = {
  schoolQuery: {
    schoolName: "",
  },
  schoolFilter: {
    levelFilterId: [],
    tagFilterId: [],
    propertyFilterId: [],
    provinceFilterId: [],
  },
  markArray: {
    levelMarkArray: [0, 0],
    tagMarkArray: [0, 0, 0],
    propertyMarkArray: [0, 0, 0, 0],
    provinceMarkArray: [
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
    ],
  },
};

export const actions = {
  //设置高校的查询名称
  setQuerySchoolName: (schoolName) => {
    return {
      type: types.SET_QUERY_SCHOOL_NAME,
      schoolName,
    };
  },

  /*------------------------分割线---------------------------*/

  //设置高校级别过滤数据
  setLevelFilterId: (levelFilterId) => {
    return {
      type: types.SET_LEVEL_FILTER_ID,
      levelFilterId,
    };
  },
  //设置高校标签过滤数据
  setTagFilterId: (tagFilterId) => {
    return {
      type: types.SET_TAG_FILTER_ID,
      tagFilterId,
    };
  },
  //设置办学性质过滤数据
  setPropertyFilterId: (propertyFilterId) => {
    return {
      type: types.SET_PROPERTY_FILTER_ID,
      propertyFilterId,
    };
  },
  //设置地区省份过滤数据
  setProvinceFilterId: (provinceFilterId) => {
    return {
      type: types.SET_PROVINCE_FILTER_ID,
      provinceFilterId,
    };
  },

  /*------------------------分割线---------------------------*/

  //设置高校层次选中标识
  setLevelMarkArray: (levelMarkArray) => {
    return {
      type: types.SET_LEVEL_MARK_ARRAY,
      levelMarkArray,
    };
  },
  //设置高校标签选中标识
  setTagMarkArray: (tagMarkArray) => {
    return {
      type: types.SET_TAG_MARK_ARRAY,
      tagMarkArray,
    };
  },
  //设置办学性质选中标识
  setPropertyMarkArray: (propertyMarkArray) => {
    return {
      type: types.SET_PROPERTY_MARK_ARRAY,
      propertyMarkArray,
    };
  },
  //设置地区选中标识
  setProvinceMarkArray: (provinceMarkArray) => {
    return {
      type: types.SET_PROVINCE_MARK_ARRAY,
      provinceMarkArray,
    };
  },
};

//院校搜索查询的院校名称
const schoolQueryData = (state = initialState.schoolQuery, action) => {
  switch (action.type) {
    case types.SET_QUERY_SCHOOL_NAME:
      return { ...state, schoolName: action.schoolName };
    default:
      return { ...state };
  }
};

//院校筛选的数据
const schoolFilterData = (state = initialState.schoolFilter, action) => {
  switch (action.type) {
    case types.SET_LEVEL_FILTER_ID:
      return { ...state, levelFilterId: action.levelFilterId };
    case types.SET_TAG_FILTER_ID:
      return { ...state, tagFilterId: action.tagFilterId };
    case types.SET_PROPERTY_FILTER_ID:
      return { ...state, propertyFilterId: action.propertyFilterId };
    case types.SET_PROVINCE_FILTER_ID:
      return { ...state, provinceFilterId: action.provinceFilterId };
    default:
      return { ...state };
  }
};

//院校筛选中标识的数据
const schoolMarkArrayData = (state = initialState.markArray, action) => {
  switch (action.type) {
    case types.SET_LEVEL_MARK_ARRAY:
      return { ...state, levelMarkArray: action.levelMarkArray };
    case types.SET_TAG_MARK_ARRAY:
      return { ...state, tagMarkArray: action.tagMarkArray };
    case types.SET_PROPERTY_MARK_ARRAY:
      return { ...state, propertyMarkArray: action.propertyMarkArray };
    case types.SET_PROVINCE_MARK_ARRAY:
      return { ...state, provinceMarkArray: action.provinceMarkArray };
    default:
      return { ...state };
  }
};

const reducer = combineReducers({
  schoolQueryData,
  schoolFilterData,
  schoolMarkArrayData,
});

export default reducer;



// WEBPACK FOOTER //
// ./src/redux/modules/schoolfilter.js